import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Form } from "react-bootstrap";
import _ from "lodash";
import moment from "moment";
import {
    getComment,
    clearComment,
    createComment,
    updateComment
} from "api/menu/master-files/workers-maintenance/actions";

class CommentModal extends React.Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);

        if (this.props.commentId) {
            this.props.getComment(this.props.workerId, this.props.commentId);
        }

        this.state = {
            commentSingle: {
                enteredBy: "",
                enteredDate: null,
                subject: "",
                body: ""
            }
        };
    }

    componentWillReceiveProps(nextProps) {
        if (!_.isEqual(nextProps.commentSingle, this.props.commentSingle)) {
            this.setState({
                commentSingle: nextProps.commentSingle
            });
        }
    }

    componentWillUnmount() {
        this.props.clearComment();
    }

    handleChange = (ev) => {
        const { name, value } = ev.target;
        const commentSingle = Object.assign({}, this.state.commentSingle);
        commentSingle[name] = value;
        this.setState({
            commentSingle
        });
    };

    handleSave = () => {
        const {
            workerId,
            commentId,
            createComment,
            updateComment,
            onSubmit
        } = this.props;
        const { commentSingle } = this.state;

        if (commentId) {
            updateComment(workerId,  commentId, commentSingle, onSubmit);
        } else {
            createComment(workerId, commentSingle, onSubmit);
        }
    };

    render () {
        const { isEditable } = this.props;
        const { commentSingle } = this.state;

        return (
            <div className="container">
                <div className="row">
                    <div className="col-6">
                        <Form.Group>
                            <Form.Label className="mr-3">Date</Form.Label>
                            <Form.Control
                                type="text"
                                readOnly
                                defaultValue={commentSingle.enteredDate
                                    ? moment(commentSingle.enteredDate).format("MMMM DD, YYYY")
                                    : ""
                                }
                            />
                        </Form.Group>
                    </div>
                    <div className="col-6">
                        <Form.Group>
                            <Form.Label className="mr-3">Entered By</Form.Label>
                            <Form.Control
                                type="text"
                                readOnly
                                defaultValue={commentSingle.enteredBy}
                            />
                        </Form.Group>
                    </div>
                    <div className="col-12">
                        <Form.Group>
                            <Form.Label className="mr-3">Subject</Form.Label>
                            <Form.Control
                                type="text"
                                readOnly={!isEditable}
                                value={commentSingle.subject}
                                onChange={this.handleChange}
                                name="subject"
                            />
                        </Form.Group>
                    </div>
                    <div className="col-12">
                        <Form.Group>
                            <Form.Label className="mr-3">Text</Form.Label>
                            <Form.Control
                                as="textarea"
                                readOnly={!isEditable}
                                value={commentSingle.body}
                                name="body"
                                onChange={this.handleChange}
                                rows={10}
                            />
                        </Form.Group>
                    </div>
                </div>
                <div className="clearfix">
                    <button
                        className="btn btn-sm btn-default float-left"
                        onClick={this.props.onCancel}
                    >
                        Close
                    </button>

                    {!isEditable ||
                        <button
                            className="btn btn-sm btn-success float-right"
                            onClick={this.handleSave}
                        >
                            Save
                        </button>
                    }
                </div>
            </div>
        );
    }
}

CommentModal.defaultProps = {
    isEditable: false
};

CommentModal.propTypes = {
    workerId: PropTypes.number.isRequired,
    isEditable: PropTypes.bool.isRequired,
    commentId: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]).isRequired,
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    commentSingle: state.workersMaintenance.commentSingle,
});

const mapStateToDispatch = dispatch => ({
    getComment: bindActionCreators(getComment, dispatch),
    clearComment: bindActionCreators(clearComment, dispatch),
    createComment: bindActionCreators(createComment, dispatch),
    updateComment: bindActionCreators(updateComment, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch,
)(CommentModal);
